var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinnedoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.14,
    height: 25.693,
    viewBox: "0 0 22.14 25.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pinned",
    transform: "translate(1.294 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7084",
    "data-name": "Path 7084",
    d: "M9.975,0S7.891,2.027,5.818,4.157C3.054,3.146,0,5.627,0,5.627l7.685,7.685S9.527,10.284,9.3,7.64c2.082-1.979,4.157-4.157,4.157-4.157",
    transform: "translate(0.267 12.088) rotate(-45)",
    fill: "none",
    stroke: "#1d3378",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63729",
    "data-name": "Line 63729",
    x2: 7.152,
    y2: 7.152,
    transform: "translate(4.688 5.057) rotate(-45)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63730",
    "data-name": "Line 63730",
    y2: 5.617,
    transform: "translate(9.718 16.499)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7208",
    "data-name": "Path 7208",
    d: "M2.728,6.823,16.393,20.357,13.21,23.92-.451,10.164Z",
    transform: "translate(0.451 -2.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63811",
    "data-name": "Line 63811",
    x2: 15.414,
    y2: 16.007,
    transform: "translate(1.45 5.22)",
    fill: "none",
    stroke: "#1d3378",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinnedoff);
export default __webpack_public_path__ + "static/media/pinnedoff.7fb4b5f967ec526388582879a913ea35.svg";
export { ForwardRef as ReactComponent };